import React from "react";
import { no_image } from '../assets/images'

export default function DisplayImageTableActivities({ ImageLog, imageTrain }) {
  return (
    <div className="div-display-image-table-activities" >
      <div className="div-image-train">
        <img className="image-components-display" src={ImageLog ? ImageLog : no_image} alt="ImageLog" />
        <div className="text-in-image-components-display">
            Train
        </div>
      </div>
      <div className="div-image-log">
        <img className="image-components-display" src={imageTrain} alt="imageTrain" />
        <div className="text-in-image-components-display">
            Log
        </div>
      </div>
    </div>
  );
}
